import { render, staticRenderFns } from "./CompletedOrder.vue?vue&type=template&id=4beb7a06"
import script from "./CompletedOrder.vue?vue&type=script&lang=js"
export * from "./CompletedOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports